import ReactDOM from 'react-dom/client'
import App from './App'
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import './style.css';


const root = ReactDOM.createRoot(document.querySelector('#root'))

root.render(
    <>
    <App />

    </>
)